// extracted by mini-css-extract-plugin
module.exports = {"question-subtitle":"style_question-subtitle__UOmDW"};